'use strict';

app.service('Api', function ($q, $timeout, $http, $location, $rootScope, $state, $stateParams) {

  var Api = this;

  Api.me = function () {
    return $http.get('/api/v1/me')
      .then(_.property('data'))
      .catch(_.constant({}))
      .then(function (user) {
        $rootScope.user = user;
        user.flowPassed = _.get(user, 'meta.profileCompleted', false) && user.persona;
      });
  };

  Api.instances = function () {
    return $http.get('/api/v1/instances')
      .then(_.property('data'))
      .then(function (instances) {
        $rootScope.instances = instances;
      });
  };

  Api.session = function () {
    return $q.all([
      Api.me(),
      Api.instances()
    ]);
  };

  Api.track = function (name, type, params, meta) {
    params = params || {};
    params.instanceId = $rootScope.instance._id;
    _.extend(params, $stateParams);
    var data = { name: name, type: type, params: params, meta: meta };

    return $http.post('/api/v1/me/history', data)
      .then(function (update) {
        _.merge($rootScope.user, update.data);
      });
  };

  Api.module = function (id) {
    return $http.get('/api/v1/me/modules/' + id)
      .then(_.property('data'));
  };

  Api.history = function (instance) {
    return $http.get('/api/v1/me/instance/' + instance._id + '/history')
      .then(_.property('data'));
  };

  var backUrl;

  var redirect = function () {
    backUrl = backUrl || $state.href('instance.app.dashboard');
    $timeout(function () {
      $location.replace().url(backUrl);
    }, 100);
  };

  Api.auth = function () {
    if (!$rootScope.user._id) {
      backUrl = $location.url();
      if (!_.startsWith(backUrl, '/app/')) {
        backUrl = '/app/';
      }
      return $q.reject({ status: 401 });
    }
  };

  Api.flow = function (state) {
    var user = $rootScope.user;
    var profile = 'instance.app.profile';
    var assessment = 'instance.app.assessmentQuiz';

    var go = function (target) {
      $timeout(function () {
        $state.go(target);
      });
      return $q.reject();
    };

    user.flowPassed = _.get(user, 'meta.profileCompleted', false) && user.persona;

    if (state == profile) { return; }
    if (!_.get(user, 'meta.profileCompleted', false)) {
      return go(profile);
    }

    if (state == assessment) { return; }
    if (!user.persona) {
      return go(assessment);
    }
  };

  Api.refresh = function () {
    return Api.me().then(redirect);
  };

  Api.login = function (userData) {
    return $http.post('/api/v1/auth', userData)
      .then(function (response) {
        $rootScope.user = response.data.data.user;
      })
      .then(redirect);
  };

  Api.logout = function () {
    return $http.post('/api/v1/auth/logout')
      .then(function () {
        $rootScope.user = {};
        $state.go('instance', {}, {reload: true});
      });
  };

});
